import type { QBus } from "@otto-ec/global-resources/event-q-bus";
import type { DresonRuleResolvedEvent } from "../../event/DresonRuleResolvedEvent";
import { moduleLogger } from "../../util/Logger";
import type { TeaserClient } from "./TeaserClient";
import type { TeaserService } from "./TeaserService";

const log = moduleLogger.scope("teaser");

export class Teaser {
	constructor(
		private readonly teaserClient: TeaserClient,
		private readonly teaserService: TeaserService,
		private readonly eventQBus: QBus,
	) {}

	init(container: HTMLElement) {
		const initialized = container.dataset.initialized;
		if (initialized && initialized === "true") {
			return;
		}

		const dreson = container.dataset.dreson;

		if (dreson) {
			this.retrieveBenefit(dreson, container);
		}
		/*                                                                            */
		this.eventQBus.on("ftfind.dresonRule.resolved", (event?: DresonRuleResolvedEvent) => {
			if (event?.rule) {
				/*                                              */
				/*                                                                                         */
				setTimeout(() => {
					this.retrieveBenefit(event.rule, container);
				}, 2_000);
			}
		});

		container.setAttribute("data-initialized", "true");

		/*               */
		this.eventQBus.once("ft9.teaser.init-tracking", () => {
			this.init_teaser(container);
		});
	}

	retrieveBenefit(dreson: string, container: HTMLElement) {
		const url = "/benefit-cinema/teaser/productlist";
		const params = new URLSearchParams();
		params.append("dreson", dreson);

		const topCinema = document.querySelector(".ft9_benefit_cinema__context_cinema--productlist > .benefit_context_cinema");
		if (topCinema !== null) {
			const slidesInTopCinema = Array.from(topCinema.getElementsByClassName("ft9-benefit-paper-card"));
			for (const benefitSlide of slidesInTopCinema) {
				if (benefitSlide instanceof HTMLElement) {
					const benefitId = benefitSlide.dataset.benefitId;
					if (benefitId) {
						params.append("benefitIdsInCinema", benefitId);
					}
				}
			}
		}

		log.info("url to request teaser benefit teaser %s", url);

		this.teaserClient
			.get(`${url}?${params.toString()}`)
			.then((response) => {
				log.info("successfully retrieved teaser benefit %s", response);

				container.innerHTML = response;
				this.init_teaser(container);
			})
			.catch((reason) => {
				log.warn("Error when requesting teaser benefit %s", dreson, reason);
			});
	}

	private init_teaser(container: HTMLElement) {
		const teaserContainer = container.getElementsByClassName("benefit-teaser-init") as HTMLCollectionOf<HTMLElement>;
		const teaserContainerElement = teaserContainer[0];
		if (teaserContainerElement !== undefined) {
			this.teaserService.initTeaser(teaserContainerElement);
		}
	}
}
